export default __webpack_public_path__ + "static/media/sample-1.857be0fb.jpeg";